import React, { useEffect, useState, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as LoginActions from "../../store/loginService/actions";
import * as LoginTypes from "../../store/loginService/types";
import * as service from "../../store/service";
import { DialogComponent } from "../common/DialogComponent";
import IDFFamilyServiceDialog from "../Dialogs/IDFFamilyServiceDialog";
import * as ConfigurationActions from "../../store/configurationService/actions";
import { Link } from "react-router-dom";
import * as MyAccountActions from "../../store/myAccount/actions";
import * as PackageServicesActions from "../../store/packageUpgradeService/actions";
import { CommonContext } from "../../CommonContextProvider";
import * as BannerMessageActions from "../../store/bannerMessage/actions";
import { ezsServiceIds } from "../../config/UserServicesList";
import { useTranslation } from "react-i18next";

const FamilyProtectionService = (props: any) => {
    const { t: tLang } = useTranslation();
    const isLoading = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.isLoading ? state.csidUserStatusState.isLoading : false
    );
    const services = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
            ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices
            : []
    );

    const { focusOnFamilyProtectionComponent }: any = useContext(CommonContext);
    const isAnyServiceAvailable = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.userServices
            ? state.loggedInUser && state.loggedInUser.userServiceDetails.userServices.length > 0
            : false
    );
    const isCCAMActive = useSelector((state: ApplicationState) => (state.loggedInUser && state.loggedInUser.userInfo?.hasCCAM ? true : false));
    const dispatch = useDispatch();
    const GetIsIdfUser = () => dispatch(MyAccountActions.actionCreators.GetIsIdfUser());
    const setRedirectToDashboard = (forceUpdate: boolean) => dispatch(ConfigurationActions.actionCreators.setRedirectToDashboard(forceUpdate));
    const familyMembers = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.familyMembers ? state.loggedInUser.familyMembers : []
    );
    let switchAbleAccounts = familyMembers.filter(
        (familyAccount) =>
            familyAccount.accountType &&
            (familyAccount.accountType.includes("child") ||
                familyAccount.accountType.includes("PRIMARY") ||
                familyAccount.accountType.includes("Family Plan Child"))
    );
    switchAbleAccounts.sort((memberX, memberY) =>
        memberX.firstName &&
        memberX.lastName &&
        memberY.firstName &&
        memberY.lastName &&
        memberX.firstName.toLocaleLowerCase() + memberX.lastName.toLocaleLowerCase() > memberY.firstName.toLocaleLowerCase() + memberY.lastName.toLocaleLowerCase()
            ? 1
            : -1
    );
    const getFamilyMembers = () => dispatch(LoginActions.actionCreators.getFamilyMembers(false));
    const setChildSubCustomerIDToCompleteAccoutSetup = (subCustomerID: string) =>
        dispatch(LoginActions.actionCreators.setChildSubCustomerIDToCompleteAccountSetup(subCustomerID));
    const switchFamilyAccount = (activeAccount: LoginTypes.IUserFamilyAccountInfo, familyMembers: LoginTypes.IUserFamilyAccountInfo[]) =>
        dispatch(LoginActions.actionCreators.switchFamilyAccount(activeAccount, props.history, familyMembers));
    const [isIDFFamilyServiceDialogVisible, setIDFFamilyServiceDialogIsVisible] = useState(false);

    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );
    const hasIDFFamilyService = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.hasFamilyService ? state.loggedInUser.hasFamilyService : false
    );
    const familyOffer = useSelector((state: ApplicationState) => (state.myAccountServiceState ? state.myAccountServiceState.familtOffer : null));
    const ezsFamilyOfferActive =
        familyOffer &&
        (familyOffer.familyAdultOffer?.hasAdultOffer
            ? familyOffer.familyAdultOffer?.hasAdultOffer
            : false || familyOffer.familyChildOffer?.hasChildOffer
            ? familyOffer.familyChildOffer?.hasChildOffer
            : false);

    const getFamilyOffer = () => dispatch(MyAccountActions.actionCreators.GetFamilyOffer());
    const isIDFUser = useSelector((state: ApplicationState) =>
        state.myAccountServiceState && state.myAccountServiceState.isIdfUser ? state.myAccountServiceState.isIdfUser : false
    );
    const [hasChildUser, setHasChildUser] = useState(false);
    const packageServicesAction = () => dispatch(PackageServicesActions.actionCreators.requestPackageData());
    const requestBannerMessage = () => dispatch(BannerMessageActions.actionCreators.getBannerAlertMessage(true));

    const showAddFamilyLink = (): any => {
        const serviceDisplayNames = ["Family", "Family 3.0 Child"];
        if (services && services.length > 0) {
            for (const serviceDisplayName of serviceDisplayNames) {
                const selectedService = services.find((service) => service && service.displayName?.toLowerCase().includes(serviceDisplayName.toLowerCase()));
                if (selectedService && selectedService.active) {
                    return true;
                }
            }
        }
        return ezsFamilyOfferActive;
    };

    const closeFamilyMemberDialog = (): any => {
        setIDFFamilyServiceDialogIsVisible(false);
    };

    useEffect(() => {
        GetIsIdfUser();
        getFamilyMembers();
        getFamilyOffer();
    }, []);

    useEffect(() => {
        if (familyMembers && familyMembers.length > 0) {
            const hasChild = familyMembers.filter((x) => x.accountType?.toLowerCase().includes("child")).length > 0 ? true : false;
            setHasChildUser(hasChild);
        }
    }, [familyMembers]);

    const requestAccountSwitch = (subcustomerID: string, accountToSwitch: any) => {
        const requestBody = { SubcustomerId: subcustomerID };

        service.switchFamilyAccount(requestBody).then((data) => {
            if (!data["hasError"] && data["familyMembers"]) {
                if (accountToSwitch) {
                    switchFamilyAccount(accountToSwitch, data["familyMembers"]);

                    const path = window.location.pathname;
                    if (path.toLowerCase().endsWith("dashboard")) {
                        setRedirectToDashboard(true);
                        props.history.push("/switch-account");
                    }

                    packageServicesAction();
                    requestBannerMessage();
                }
            }
        });
    };

    const switchUserAccount = (subcustomerID: string) => {
        const accountToSwitch: any = familyMembers.find((x) => x.subcustomerId === subcustomerID);

        if (accountToSwitch && accountToSwitch.accountType && accountToSwitch.accountType.toLocaleLowerCase().includes("primary")) {
            requestAccountSwitch(subcustomerID, accountToSwitch);
        } else {
            if (isIDFUser) {
                const requestBody = {
                    childAccountID: accountToSwitch && accountToSwitch.userId ? accountToSwitch.userId : " ",
                };

                service
                    .checkCompleteAccountSetup(requestBody)
                    .then((data) => {
                        if (data.isAccountSetupCompleted) {
                            requestAccountSwitch(subcustomerID, accountToSwitch);
                        } else {
                            if (accountToSwitch) {
                                setChildSubCustomerIDToCompleteAccoutSetup(subcustomerID);
                                props.history.push("/complete-family-setup");
                            }
                        }
                    })
                    .catch(() => {});
            } else {
                if (isCCAMActive ? true : accountToSwitch && accountToSwitch.setUpCompleteDate != null) {
                    requestAccountSwitch(subcustomerID, accountToSwitch);
                } else {
                    if (accountToSwitch) {
                        setChildSubCustomerIDToCompleteAccoutSetup(subcustomerID);
                        props.history.push("/complete-family-setup");
                    }
                }
            }
        }
    };

    if (!hasIDFFamilyService) {
        return <React.Fragment></React.Fragment>;
    }

    return (
        <React.Fragment>
            {isAnyServiceAvailable && (hasChildUser || !isPrimaryAccount) && familyMembers && familyMembers.length > 0 && (
                <div className="account-area-list">
                    <h4 className="section_title">Switch Account</h4>

                    <div style={{ overflowY: "auto", maxHeight: "360px" }}>
                        <ul role="menu" className="submenu-links">
                            {switchAbleAccounts.map((member) => {
                                const accountType = member.accountType ? member.accountType.toLowerCase() : "";
                                let isAccountCouldBeSwitch = accountType.includes("child") || accountType.includes("primary") ? true : false;
                                if (!member.registrationStatus) {
                                    isAccountCouldBeSwitch = false;
                                }

                                const subcustomerID = member.subcustomerId ? member.subcustomerId : "";

                                return (
                                    <li key={member.subcustomerId} role="presentation">
                                        <a
                                            onClick={(e) => {
                                                e.preventDefault();
                                                if (isAccountCouldBeSwitch) {
                                                    switchUserAccount(subcustomerID);
                                                }
                                            }}
                                            href="#"
                                            role="menuitem"
                                        >
                                            <em className={isAccountCouldBeSwitch ? "las la-user-circle" : "las la-lock"}></em>
                                            <span className="sr-only">Switch Account to</span>
                                            {" " + member.firstName + " " + member.lastName}
                                        </a>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            )}
            {showAddFamilyLink() && isPrimaryAccount && !isLoading && (
                <div className="account-area-add">
                    <Link to="/manage-account/my-account#family-protection" onClick={focusOnFamilyProtectionComponent} className="default_link">
                        {tLang("dashboard.userMenuDropdown.manageFamilyProtection")}
                    </Link>
                </div>
            )}

            {isIDFFamilyServiceDialogVisible && (
                <DialogComponent
                    dialogId="dialog-add-family-member-account-dialog-idf-family-service"
                    title="Add Family Member"
                    closeDialog={closeFamilyMemberDialog}
                >
                    <IDFFamilyServiceDialog
                        history={props.history}
                        dialogId="dialog-add-family-member-account-dialog-idf-family-service"
                        closeDialog={closeFamilyMemberDialog}
                    />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default FamilyProtectionService;
